import { useState } from 'react'
import Button from 'components/general/Button'
import Icon from 'components/general/Icon'
import COLORS from 'constants/Colors'
import styles from './styles.module.scss'
import { ActionMenuButtonProps } from './types'

export default function ActionMenuButton({
   preventDefaultNavigation,
   rowIndex,
   disabled,
   setIndex,
   onClick,
   handleTourPath,
   deleteRowIndex,
   deleteRowAPI,
   handleEdit,
   removeEdit,
   isFromPathwayPage,
}: ActionMenuButtonProps & {
   preventDefaultNavigation?: boolean
   removeEdit?: boolean
}) {
   const [isMenuOpen, setIsMenuOpen] = useState(false)

   const handleBtnClick = (e: any) => {
      if (preventDefaultNavigation) {
         e.stopPropagation()
         e.preventDefault()
      }
      onClick()
      setIsMenuOpen((prev) => !prev)
      if (!isMenuOpen) {
         setIndex(rowIndex)
      } else {
         setIndex(null)
      }
   }

   const handleClickEdit = () => {
      handleEdit()
      setIsMenuOpen(false)
   }

   const handleClickDelete = (e: any) => {
      // handleDelete(rowIndex);
      if (preventDefaultNavigation) {
        e.stopPropagation()
        e.preventDefault()
     }
      deleteRowAPI(deleteRowIndex, rowIndex)
      setIsMenuOpen(false)
      setIndex(null)
   }

   const showOnlyEdit = !!isFromPathwayPage

   return (
      <div
         className={styles.mainBtn}
         style={{
            position: 'relative',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
         }}
      >
         <Button
            btnClassName={`${styles.actionEditBtn}`}
            disabled={disabled}
            onClick={handleBtnClick}
            isOutline
         >
            <Icon name="more" size={23} color="IconGray2" />
         </Button>
         {isMenuOpen &&
            (removeEdit ? (
               <button
                  className={`${styles.floatingMenu}`}
                  onClick={handleClickDelete}
                  style={{ color: COLORS.MainDanger, top: '0px' }}
               >
                  Delete
               </button>
            ) : (
               <ul className={`${styles.floatingMenu}`}>
                  <button onClick={handleClickEdit}>Edit</button>
                  {!showOnlyEdit && (
                     <button
                        onClick={handleClickDelete}
                        style={{ color: COLORS.MainDanger }}
                     >
                        Delete
                     </button>
                  )}
               </ul>
            ))}
         {/* {isMenuOpen && (
           { removeEdit ? <></> : <></>}

            <ul className={`${styles.floatingMenu}`}>
               <button onClick={handleClickEdit}>Edit</button>
               {!showOnlyEdit && (
                  <button
                     onClick={handleClickDelete}
                     style={{ color: COLORS.MainDanger }}
                  >
                     Delete
                  </button>
               )}
            </ul>
         )} */}
      </div>
   )
}
